module.exports = __webpack_public_path__ + "static/img/Homev3.c3e13f3.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/color/color-2/Homev3.png
// module id = f/Y6
// module chunks = 0